import { HTTP_DESKRH } from '../http';

export default {

  login(searchParams) {
    return HTTP_DESKRH.post('desk-daf-user/login', searchParams)
      .then(response => response);
  },

};



// WEBPACK FOOTER //
// ./src/api/login.js